export const parseResponseFakeRelatedSearchSuggestions = (response) => {
  if (response && response.suggestions) {
    return response.suggestions.map((data, key) => {
      return {
        group: "external",
        index: key,
        result: data,
      };
    });
  }
  return null;
};
